var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "withdraw md-layout md-alignment-center-center" },
    [
      _c("div", { staticClass: "container-header" }, [
        _c("div", { staticClass: "container-header__title" }, [
          _vm._v(_vm._s(_vm.i18n.withdraw_withdrawal()))
        ])
      ]),
      _vm._v(" "),
      _vm.view.mode === _vm.VIEW_MODES.submit && _vm.tokenCodes.length
        ? [
            _c(
              "form",
              {
                staticClass:
                  "md-layout-item md-size-50 md-medium-size-65 md-small-size-95 md-xsmall-size-100",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.processTransfer.apply(null, arguments)
                  }
                }
              },
              [
                _c(
                  "md-card",
                  {
                    staticClass: "container container_40",
                    class: { grey: _vm.colorTron === "Gray" }
                  },
                  [
                    _vm.isPending
                      ? _c("md-progress-bar", {
                          attrs: { "md-mode": "indeterminate" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isTron
                      ? _c(
                          "div",
                          { staticClass: "withdraw__user-balance text_medium" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.i18n.lbl_current_balance({
                                    amount: _vm.swimBalance,
                                    asset: _vm.formatToken
                                  })
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "withdraw__user-balance text_medium" },
                          [
                            _c("p", { staticClass: "bold" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.i18n.lbl_current_balance({
                                      amount: _vm.greyWhiteTronSum,
                                      asset: _vm.formatToken
                                    })
                                  ) +
                                  "\n          "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.i18n.white_wallet()) +
                                  ": " +
                                  _vm._s(_vm.swimBalance) +
                                  " " +
                                  _vm._s(_vm.formatToken)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.i18n.gray_wallet()) +
                                  ": " +
                                  _vm._s(_vm.greyTronValue) +
                                  " " +
                                  _vm._s(_vm.formatToken)
                              )
                            ])
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "p",
                          { staticClass: "withdraw__explanations text_large" },
                          [
                            _vm.commissionDescription
                              ? [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.commissionDescription) +
                                      "\n            "
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm.isTron
                          ? _c(
                              "div",
                              { staticClass: "swticher-tron" },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.i18n.white_wallet()))
                                ]),
                                _vm._v(" "),
                                _c("md-switch", {
                                  staticClass: "md-primary",
                                  model: {
                                    value: _vm.colorTronSwitch,
                                    callback: function($$v) {
                                      _vm.colorTronSwitch = $$v
                                    },
                                    expression: "colorTronSwitch"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.i18n.gray_wallet()))
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "md-layout withdraw__flex-wrapper" },
                          [
                            _c("select-field3", {
                              staticClass: "md-layout-item withdraw__select",
                              class: { grey: _vm.colorTron === "Gray" },
                              attrs: {
                                label: _vm.i18n.lbl_choose_asset(),
                                values: _vm.tokensCodeFormatted
                              },
                              on: { change: _vm.checkLimit },
                              model: {
                                value: _vm.form.tokenCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "tokenCode", $$v)
                                },
                                expression: "form.tokenCode"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "md-layout-item withdraw__field" },
                              [
                                _c("input-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|amount",
                                      expression: "'required|amount'"
                                    }
                                  ],
                                  staticClass: "field__number",
                                  class: { grey: _vm.colorTron === "Gray" },
                                  attrs: {
                                    label: _vm.i18n.lbl_amount(),
                                    name: "amount",
                                    type: "number",
                                    title: "Amount",
                                    align: "right",
                                    vvValidateOn: "change",
                                    errorMessage:
                                      _vm.errors.first("amount") ||
                                      (_vm.isLimitExceeded
                                        ? _vm.i18n.withdraw_error_insufficient_funds()
                                        : "") ||
                                      (_vm.isWithdrawLimitExceeded
                                        ? _vm.i18n.withdraw_error_maximum_amount(
                                            {
                                              value:
                                                _vm.maxAmounts[
                                                  _vm.form.tokenCode
                                                ],
                                              asset: _vm.formatToken
                                            }
                                          )
                                        : "") ||
                                      (_vm.lessThenMinimumAmount
                                        ? _vm.i18n.withdraw_error_minimum_amount(
                                            {
                                              value: _vm.minAmount,
                                              asset: _vm.formatToken
                                            }
                                          )
                                        : "")
                                  },
                                  on: {
                                    blur: function($event) {
                                      _vm.checkLimit(), _vm.checkAmount()
                                    }
                                  },
                                  model: {
                                    value: _vm.form.amount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "amount",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "form.amount"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.form.amount && _vm.form.amount > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "withdraw__fees-container text_medium",
                                class: { loading: _vm.isFeesLoadPending }
                              },
                              [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.i18n.fees_percent_fixed({
                                        percent: _vm.allFees.percent,
                                        fixed: _vm.allFees.fixed,
                                        currency: _vm.formatToken
                                      })
                                    ) + "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.isFeesCharged()
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.i18n.fees_will_charged({
                                            willCharged: _vm.willCharged,
                                            currency: _vm.formatToken
                                          })
                                        ) + "\n            "
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.limitList
                          ? _c(
                              "div",
                              {
                                staticClass: "withdraw__fees-container",
                                class: { loading: _vm.isFeesLoadPending }
                              },
                              [
                                _vm._l(_vm.limitList, function(item, key) {
                                  return [
                                    item.period === "operation" ||
                                    item.period === "day"
                                      ? _c("div", { key: key }, [
                                          _c("p"),
                                          _vm._v(" "),
                                          item.period === "operation"
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.i18n.lim_withdrawal_daily_msg1(
                                                      {
                                                        limit:
                                                          item.amount_limit,
                                                        asset: _vm.formatToken
                                                      }
                                                    )
                                                  ) + "\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.period === "day"
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.i18n.lim_withdrawal_daily_msg2(
                                                      {
                                                        limit:
                                                          item.amount_limit,
                                                        asset: _vm.formatToken
                                                      }
                                                    )
                                                  ) + "\n                "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.i18n.lim_withdrawal_daily_msg3()
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ]
                                })
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.form.wallets, function(value, key) {
                          return _c(
                            "div",
                            [
                              key === _vm.form.tokenCode &&
                              _vm.isCryptoToken(_vm.form.tokenCode)
                                ? _c("input-field", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value:
                                          "required|" + _vm.addressRuleFor(key),
                                        expression:
                                          "`required|${addressRuleFor(key)}`"
                                      }
                                    ],
                                    staticClass: "md-layout-item",
                                    class: { grey: _vm.colorTron === "Gray" },
                                    attrs: {
                                      autocomplete: false,
                                      label: _vm.getDirections(
                                        _vm.WITHDRAW_DIRECTION.external
                                      ),
                                      name: key,
                                      id: key,
                                      errorMessage:
                                        _vm.errors.first(key) ||
                                        (_vm.isTryingToSendToYourself
                                          ? _vm.i18n.withdraw_error_is_trying_to_send_to_yourself()
                                          : "")
                                    },
                                    model: {
                                      value: _vm.form.wallets[key],
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form.wallets,
                                          key,
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.wallets[key]"
                                    }
                                  })
                                : _vm.form.tokenCode === key
                                ? _c("input-field", {
                                    staticClass: "md-layout-item",
                                    class: { grey: _vm.colorTron === "Gray" },
                                    attrs: {
                                      name: "direction",
                                      readonly: true,
                                      value: _vm.getDirections(
                                        _vm.WITHDRAW_DIRECTION.cashbox
                                      )
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.checkLimit()
                                      }
                                    },
                                    model: {
                                      value: _vm.form.direction,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "direction",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.direction"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.first(key)
                                ? _c("span", { staticClass: "danger" }, [
                                    _vm._v(_vm._s(_vm.errors.first(key)))
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "btn-wrap" },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass: "btn md-primary md-yellow w-100",
                            attrs: { type: "submit", disabled: !_vm.isCashable }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.i18n.withdraw_withdraw()) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm.view.mode === _vm.VIEW_MODES.confirm
        ? [
            _c("confirm-withdraw", {
              staticClass:
                "container container_40 md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100",
              attrs: {
                opts: _vm.view.opts,
                limitList: _vm.limitList,
                isPending: _vm.isPending
              },
              on: {
                "cancel-click": function($event) {
                  return _vm.updateView(_vm.VIEW_MODES.submit)
                },
                "confirm-click": _vm.submit
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.view.mode === _vm.VIEW_MODES.success
        ? [
            _c(
              "md-card",
              {
                staticClass:
                  "container container_40 withdraw__success-msg md-layout-item md-size-50 md-medium-size-45 md-small-size-100 md-xsmall-size-100",
                class: { grey: _vm.colorTron === "Gray" }
              },
              [
                _c("div", { staticClass: "md-title" }, [
                  _vm._v(_vm._s(_vm.i18n.withdraw_success()))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "withdraw__success-amount" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.swimAmount) +
                      " " +
                      _vm._s(_vm.formatToken) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-wrap space-between margin-top" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary w-100",
                        on: {
                          click: function($event) {
                            return _vm.updateView(
                              _vm.VIEW_MODES.submit,
                              {},
                              true
                            )
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.lbl_go_back()) +
                            "\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "md-button",
                      {
                        staticClass: "btn md-primary md-yellow w-100",
                        attrs: { to: "/history/index/" + _vm.form.tokenCode }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.i18n.lbl_view_history()) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.tokenCodes.length
        ? [
            _c(
              "md-card",
              {
                staticClass:
                  "container container_40 md-layout-item md-size-50 md-medium-size-65 md-small-size-95 md-xsmall-size-100"
              },
              [
                _c(
                  "div",
                  { staticClass: "container__no-data" },
                  [
                    _c("md-icon", { staticClass: "md-size-4x" }, [
                      _vm._v("credit_card")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_large" }, [
                      _vm._v(_vm._s(_vm.i18n.withdraw_no_assets()))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "text_description text_margin text_medium"
                      },
                      [_vm._v(_vm._s(_vm.i18n.withdraw_no_assets_exp()))]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e6a4640", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e6a4640","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/withdrawal/make/Withdrawal.Make.vue
// module id = gxyJ
// module chunks = 1